/* src/components/RuleDossier.js */
import React from 'react';
import './CorpusJurisView.css';

const getStatusIcon = (status) => {
  switch (status) {
    case 'mastered': return 'verified';
    case 'in_progress': return 'timelapse';
    default: return 'radio_button_unchecked';
  }
};

function RuleDossier({ rule, onInfoClick, onLearnClick, onToggleFlag, hnuDepth }) {
  const status = rule.status || 'not_started';
  const isQuiz = rule.itemType === 'quiz';
  
  const dossierClasses = [
    'rule-dossier',
    isQuiz ? 'quiz-dossier' : '',
    `status-${status}`,
    rule.isFlagged ? 'is-flagged' : '',
    `depth-${hnuDepth || 0}`
  ].join(' ');

  const handleActionClick = (e, action) => {
    e.stopPropagation();
    action(rule.id);
  };

  return (
    <div className={dossierClasses} onClick={() => onInfoClick(rule)}> 
      <div className="dossier-content-wrapper">
        <div className="dossier-details">
          <span className="material-symbols-outlined status-icon">
            {isQuiz ? (status === 'mastered' ? 'check_circle' : 'quiz') : getStatusIcon(status)}
          </span>
          <h3 className="rule-name">{rule.ruleName}</h3>
        </div>

        <div className="dossier-actions">
          <button className="action-icon-btn" onClick={(e) => handleActionClick(e, onLearnClick)} title="Learn">
            <span className="material-symbols-outlined">school</span>
          </button>
          
          <button className={`action-icon-btn flag-btn ${rule.isFlagged ? 'active' : ''}`} onClick={(e) => handleActionClick(e, onToggleFlag)} title={rule.isFlagged ? 'Unflag Rule' : 'Flag Rule'}>
            <span className="material-symbols-outlined">{rule.isFlagged ? 'flag' : 'outlined_flag'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default RuleDossier;